import { render, staticRenderFns } from "./invoiceImg.vue?vue&type=template&id=c418a490&scoped=true"
import script from "./invoiceImg.vue?vue&type=script&lang=js"
export * from "./invoiceImg.vue?vue&type=script&lang=js"
import style0 from "./invoiceImg.vue?vue&type=style&index=0&id=c418a490&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c418a490",
  null
  
)

export default component.exports